"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var nameProvider = null;
var dataFile = null;

var setNameProvider = function setNameProvider(np) {
    return nameProvider = np;
};
var getNameProvider = function getNameProvider() {
    return nameProvider;
};

var setDataFile = function setDataFile(df) {
    return dataFile = df;
};
var getDataFile = function getDataFile() {
    return dataFile;
};

exports.setNameProvider = setNameProvider;
exports.getNameProvider = getNameProvider;
exports.setDataFile = setDataFile;
exports.getDataFile = getDataFile;